import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { BasisSystem1cService } from '@zaoblako/web/core/services/basis/basis-system-1c.service';
import { ErrorService } from '@zaoblako/web/core/services/error.service';
import { FileUploaderComponent } from '@zaoblako/web/shared/components/file-uploader/file-uploader.component';
import { FormType } from '@zaoblako/web/shared/components/form-sidebar/models/form-state';
import { FormStoreService } from '@zaoblako/web/shared/components/form-sidebar/services/form-store.service';
import { BaseFormComponent } from '@zaoblako/web/shared/dumbs/base-form/base-form.component';
import { EditorComponent } from '@zaoblako/web/shared/dumbs/editor/editor.component';
import { InputTextComponent } from '@zaoblako/web/shared/dumbs/input-text/input-text.component';
import { SpinnerComponent } from '@zaoblako/web/shared/dumbs/spinner/spinner.component';
import { JoinPipe } from '@zaoblako/web/shared/pipes/join.pipe';
import {
  Plugin1cFrontendFormDto,
  type Plugin1cFrontendFormInterface
} from '@zaoblako/shared/modules/integration/dtos/plugin-1c/plugin-1c-frontend-form.dto';
import type { FileFindInterface } from '@zaoblako/shared/modules/storage/dtos/file/file-find.dto';
import { ButtonComponent } from '@zaoblako/web/shared/dumbs/button/button.component';
import { CardModule } from 'primeng/card';
import { Observable } from 'rxjs';

@Component({
  selector: 'crm-extension1c-form',
  standalone: true,
  imports: [
    CommonModule,
    InputTextComponent,
    JoinPipe,
    FileUploaderComponent,
    CardModule,
    ButtonComponent,
    EditorComponent,
    SpinnerComponent
  ],
  templateUrl: './extension1c-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class Extension1cFormComponent extends BaseFormComponent<Plugin1cFrontendFormInterface> implements OnInit {
  @Input() public readonly index: number;
  public form = <Plugin1cFrontendFormInterface>{};
  public dto = Plugin1cFrontendFormDto;
  public form$: Observable<FormType>;
  public loading$: Observable<boolean>;

  public constructor(
    private readonly basisSystem1cService: BasisSystem1cService,
    public readonly formStoreService: FormStoreService,
    private readonly cdRef: ChangeDetectorRef,
    private readonly errorService: ErrorService
  ) {
    super();
  }

  public ngOnInit() {
    this.form$ = this.formStoreService.select((state) => state.forms[this.index]);
    this.loading$ = this.formStoreService.select((state) => state.forms[this.index]?.loading);

    if (!this.formStoreService.getState.forms[this.index]?.isEdit) {
      this.basisSystem1cService.getLatest(['versionMajor', 'versionMinor', 'versionPatch']).subscribe((plugin) => {
        if (plugin) {
          this.form.version = `${plugin.versionMajor}.${plugin.versionMinor}.${plugin.versionPatch + 1}`;
          this.cdRef.markForCheck();
        }
      });
    }
  }

  public saveExtension() {
    if (this.checkValidate(this.form).valid) {
      this.formStoreService.setLoading(true, this.index);

      const { version, ...body } = this.form;
      this.basisSystem1cService.setVersion(version, body).subscribe({
        next: () => {
          this.formStoreService.setLoading(false, this.index);
          this.errorService.addSuccessMessage('Версия расширения создана');
          this.formStoreService.saveNext(null, this.index);
        },
        error: () => {
          this.formStoreService.setLoading(false, this.index);
        }
      });
    }
  }

  public setFile(files: FileFindInterface[]) {
    this.form.file = files[0];
  }
}
